const custom = function () {
    "use strict";

    // ==============================================================
    // This is for the top header part and sidebar part
    // ==============================================================

    jQuery(document).on('click', '.mega-dropdown', function (e) {
        e.stopPropagation()
    });

    const minisidebar = function(mini = false) {
        if (!mini) {
            $("body").trigger("resize");
            $("body").removeClass("mini-sidebar");
        } else {
            $("body").trigger("resize");
            $("body").addClass("mini-sidebar");
        }
    }

    // ==============================================================
    // Theme options
    // ==============================================================
    $(".sidebartoggler").on('click', function () {
        if ($("body").hasClass("mini-sidebar")) {
            minisidebar(false);
            localStorage.setItem('miniSidebar', 'false');
        } else {
            minisidebar(true);
            localStorage.setItem('miniSidebar', 'true');
        }
    });

    if(localStorage.getItem('miniSidebar') === 'true') {
        minisidebar(true);
    } else {
        minisidebar(false);
    }

    // this is for close icon when navigation open in mobile view
    $(".nav-toggler").click(function () {
        $("body").toggleClass("show-sidebar");
        $(".nav-toggler i").toggleClass("ti-menu");
        $(".nav-toggler i").addClass("ti-close");
    });

    // ==============================================================
    // Perfect scrollbar
    // ==============================================================
    $('.scroll-sidebar').perfectScrollbar();

    $("body").trigger("resize");

    // For Custom File Input
    $('.custom-file-input').on('change',function(){
        //get the file name
        var fileName = $(this).val();
        //replace the "Choose a file" label
        $(this).next('.custom-file-label').html(fileName);
    })
};

export default custom;